import GeneticsSearchText from '../../../Sections/SectionGenetics/GeneticsSearchText';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import { GetGeneTable } from './GetGeneTable';



export default function SectionGeneticsSearch() {

    
    return (

    <SectionStructure
    
            sectiontext=    { <GeneticsSearchText /> }

            sectioncards=  { <GetGeneTable />  }
    />
    )
}